export default "__VITE_ASSET__BOmXAZsr__"